import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import Button from './Button';

const Container = styled.div`
	height: 100vh;
	font-weight: bolder;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
`;

const Header = styled.h1`
  padding:0 0 2rem 0;
`;


export const Error = () => {
  return (
    <Container>
      <Header>An error as occured.</Header>
      <NavLink to={"/"} ><Button active >Go back</Button></NavLink>
  </Container>
  )
}
